import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// import Icon from "@mdi/react";
// import { mdiClose, mdiClipboardListOutline } from "@mdi/js";
import moment from "moment";
// import { getBranch } from "utils/utils";
import NumberFormat from "react-number-format";
import TicketApi from "service/ticketApi";
import Modal from "react-bootstrap/Modal";

export const ModalChiTiet = ({ toggleModal, isModalVisible, item }) => {
  const [chiTietTicket, setChiTietTicket] = useState({});
  useEffect(() => {}, []);
  return (
    <Modal
      show={isModalVisible}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
          </span>{" "}
          Chi tiết ticket
        </h4>
        <button type="button" className="close-popup-new" onClick={toggleModal}>
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <div class="body-detail-bc">
          <div class="form-money-2" style={{ marginBottom: "5px" }}>
            <div class="row">
              <div class="col-sm-6">
                <span style={{fontWeight:"bold"}} >Tiêu đề:</span> {item.TieuDe}
              </div>
              <div class="col-sm-6">
                <span  style={{fontWeight:"bold"}}>Chức năng báo lỗi: </span>{" "}
                {item.ChucNang === "NoPhaiThu"
                  ? "Công nợ"
                  : item.ChucNang === "CamDo"
                  ? "Cầm đồ"
                  : item.ChucNang === "TinChap"
                  ? "Tín chấp"
                  : item.ChucNang === "TraGop"
                  ? "Trả góp"
                  : item.ChucNang === "Khac"
                  ? "Chức năng khác"
                  : "Chức năng khác"}
              </div>
            </div>
          </div>
          <div class="table-Main-content table-border-new2 table-border-popup">
            <table class="table">
              <thead>
                <tr>
                  <th class="text-center">
                    <span>Trạng thái</span>
                  </th>
                  <th class="text-center">
                    <span>Deadline</span>
                  </th>
                  <th class="text-left">
                    <span>Phản hồi</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {typeof item.LichSuXuLy != "undefined" &&
                item.LichSuXuLy.length > 0 ? (
                  item.LichSuXuLy.map((itemSelect, indexSelect) => {
                    return (
                      <>
                        <tr class="">
                          <td class="text-center">{itemSelect.TenTrangThai}</td>
                          <td class="text-center">
                            {itemSelect.Deadline === "1900-01-01T00:00:00"
                              ? ""
                              : itemSelect.Deadline === null
                              ? ""
                              : moment(itemSelect.Deadline).format(
                                  "DD/MM/YYYY"
                                )}
                          </td>
                          <td class="text-left">{itemSelect.NoiDung}</td>
                        </tr>
                      </>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="3">Không có dữ liệu</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div class="from-button-modal">
          <div class="row">
            <div class="col-md-9"></div>
            <div class="col-md-3 text-right">
              <button
                type="button"
                class="btn btn-new-main btn-closenew"
                onClick={toggleModal}
              >
                <span class="btn-icon-left">
                  <i class="mdi mdi-close"></i>
                </span>
                Đóng
              </button>
            </div>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
